import { createPersonalListFilter } from '../../factories';
import { fetchPersonalList } from '../../services/personalList';

type FetchPersonalListArgs = {
  listType: number;
};

export async function fetchPersonalLineup({ listType }: FetchPersonalListArgs) {
  const { objects } = await fetchPersonalList({
    filter: createPersonalListFilter({
      orderBy: 'CREATE_DATE_DESC',
      partnerListTypeIn: String(listType),
    }),
  });

  if (!objects.length) {
    return {
      personalLineup: [],
      allLineups: [],
    };
  }

  const personalLineup = objects[0];

  try {
    const json = JSON.parse(personalLineup.ksql) as { UserPersonalLineup?: Array<{ id: number; lcn: number }> };

    return {
      personalLineup: json.UserPersonalLineup ?? [],
      // lineups are needed in order to clean up obsolete one after a new lineup submitted by user
      allLineups: objects.map((i) => i.id),
    };
  } catch (error) {
    return {
      personalLineup: [],
      allLineups: objects.map((i) => i.id),
    };
  }
}
